function ST_RNTR_DT(){
  var Rntr_prd_tag = document.getElementById("main-cart-items").getElementsByClassName("Rntr_cls_tag");
  if(Rntr_prd_tag.length > 0){
    document.getElementById("subm_date_err").className = "subm_err_hid";
    var conf_text = "";
    var date_value = [];
    var INP_LIST = document.getElementById("Cart_Date_Body").getElementsByClassName("Cart_date_inputBox");
    for( var i = 0; i < INP_LIST.length; i++ ){
      var INP_value = INP_LIST[i].value;
      var num = i + 1;
      if(INP_value != ""){
        date_value.push("N" + num + ":" + INP_value);
      };
    };
    if(date_value.length > 0){
      var note_value = date_value.join("_");
      document.getElementById("Cart-note").value = note_value;
      document.getElementById("cls_foot_Y").style = "";
      document.getElementById("Date_conf").className = "date_conf_cls";
    }else{
      document.getElementById("subm_date_err").className = "subm_err";
    };
  }else{
    document.getElementById("checkout").click();
  };
};

function date_conf_N(){
  document.getElementById("Date_conf").className = "date_conf_cls_hid";
};

function date_conf_Y(){
  document.getElementById("cls_foot_Y").style = "background-color:#8fddeb";
  document.getElementById("checkout").click();
};

/*-_-_-_-_-_-_ date_crndr _-_-_-_-_-_-*/
function Reset_crnd_id(){
  /*document.getElementById("crnd_prev_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp";
  /*document.getElementById("crnd_next_id").className = "crnd_next";*/
};

function GeneCrnd(Gene_Cnf){
  if(Gene_Cnf == "L"){
    /*var T_Date_Set = new Date();
    var T_year = T_Date_Set.getFullYear();
    var T_month = T_Date_Set.getMonth();*/
    var Curr_Day = new Date();
    var Curr_Day_value = Curr_Day.getFullYear() + "-" + ("00" + (Curr_Day.getMonth() + 1)).slice(-2) + "-" + ("00" + Curr_Day.getDate()).slice(-2);
    var Min_Day = new Date(Curr_Day_value);
    Min_Day.setDate(Min_Day.getDate() + 30);
    var T_year = Min_Day.getFullYear();
    var T_month = Min_Day.getMonth();
  }else if(Gene_Cnf == "P"){
    var T_year = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_Y").split("+")[0]);
    var T_month = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_M").split("+")[0]);
  }else if(Gene_Cnf == "N"){
    var T_year = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_Y").split("+")[1]);
    var T_month = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_M").split("+")[1]);
  };
  
  var Year_set = [];
  var Month_set = [];
  
  if(T_month == 0){
    Year_set = [T_year -1,T_year -1,T_year,T_year];
    Month_set = [11,11,0,1];
  }else if(T_month == 11){
    Year_set = [T_year,T_year,T_year,T_year + 1];
    Month_set = [10,10,11,0];
  }else{
    Year_set = [T_year,T_year,T_year,T_year];
    Month_set = [T_month - 1,T_month - 1,T_month,T_month + 1];
  };
  
  var Crnd_date_Arr = [];
  var C_Base_Date = new Date(Year_set[0], Month_set[0], 1).getDay() - 1;
  var C_date_Last = new Date(Year_set[0], Month_set[0], 0);
  for (var a = C_date_Last.getDate() - C_Base_Date; a <= C_date_Last.getDate(); a++) {
      Crnd_date_Arr.push(a);
  };
  for(var aa = 1;aa < 4; aa++){
    var C_date_First = new Date(Year_set[aa], Month_set[aa], 1);
    var C_date_Last = new Date(Year_set[aa], Month_set[aa] + 1, 0);
    if(aa == 2){var Abl_S = Crnd_date_Arr.length;};
    for (var a = C_date_First.getDate(); a <= C_date_Last.getDate(); a++) {
        Crnd_date_Arr.push(a);
    };
    if(aa == 2){var Abl_F = Crnd_date_Arr.length;};
  };
  var ad_arr =  106 - Crnd_date_Arr.length;
  for (var a = 1; a <= ad_arr; a++) {
      Crnd_date_Arr.push(a);
  };

  var Curr_Day = new Date();
  var Curr_Day_value = Curr_Day.getFullYear() + "-" + ("00" + (Curr_Day.getMonth() + 1)).slice(-2) + "-" + ("00" + Curr_Day.getDate()).slice(-2);
  var Min_Day = new Date(Curr_Day_value);
  Min_Day.setDate(Min_Day.getDate() + 10);
  var Min_Day_value = parseInt(Min_Day.getFullYear() + ("00" + (Min_Day.getMonth() + 1)).slice(-2) + ("00" + Min_Day.getDate()).slice(-2));
  
  for(var b = 0;b <= 104; b++){
    c = b + 1
    var Check_day = parseInt(Year_set[2] + ("00" + (Month_set[2] + 1)).slice(-2) + ("00" + Crnd_date_Arr[b]).slice(-2));
    document.getElementById("crnd_week_date_id_" + c).getElementsByClassName("crnd_td")[0].textContent = Crnd_date_Arr[b];
    document.getElementById("crnd_td_radio_id_" + c).checked = false;
    document.getElementById("crnd_td_radio_id_" + c).disabled = false;
    document.getElementById("crnd_week_date_id_" + c).style = "";
    if(b < Abl_S || b > Abl_F - 1){
      document.getElementById("crnd_week_date_id_" + c).style = "background-color:#ededed;";
      document.getElementById("crnd_week_date_id_" + c).getElementsByClassName("crnd_td")[0].textContent = "";
      document.getElementById("crnd_td_radio_id_" + c).disabled = true;
    };
    
    if(Min_Day_value > Check_day){
      document.getElementById("crnd_week_date_id_" + c).style = "background-color:#ededed;";
      document.getElementById("crnd_td_radio_id_" + c).disabled = true;
    };
  };
 
  document.getElementById("Deli_date_crndr").setAttribute("data-SET_Y",Year_set[1] + "+" + Year_set[3]);
  document.getElementById("Deli_date_crndr").setAttribute("data-SET_M",Month_set[1] + "+" + Month_set[3]);
  document.getElementById("deli_crnd_head_year").textContent = Year_set[2];
  document.getElementById("deli_crnd_head_month").textContent = Month_set[2] + 1;
};

function Crnd_btn_Prev(){
  /*document.getElementById("crnd_disp_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp_hid";
  GeneCrnd("P");
  setTimeout(function(){ Reset_crnd_id(); },250);
};
function Crnd_btn_Next(){
  /*document.getElementById("crnd_disp_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp_hid";
  GeneCrnd("N")
  setTimeout(function(){ Reset_crnd_id(); },250);
};
function Crnd_btn_Rst(){
  var Date_inp_id = document.getElementById("Deli_date_crndr").getAttribute("data-focs_date");
  document.getElementById(Date_inp_id).value = "";
};
function Crnd_btn_Close(){
  document.getElementById("Deli_date_crndr").className = "Deli_date_crndr_hid";
};

window.onload = GeneCrnd("L");

function Focs_INP(INP){
  document.getElementById("Deli_date_crndr").className = "Deli_date_crndr";
  document.getElementById("Deli_date_crndr").setAttribute("data-focs_date",INP);
  var crndr_elem = document.getElementById("Deli_date_crndr");
  var move_to = document.getElementById(INP.replace("_input",""));
  move_to.after(crndr_elem);
};

function SelecD(T_ele){
  var Crndr_date_value = document.getElementById(T_ele).getElementsByClassName("crnd_td")[0].textContent;
  if(Crndr_date_value != "" && document.getElementById(T_ele).getElementsByClassName("crnd_td_radio")[0].disabled != true){
    var Date_inp = document.getElementById("Deli_date_crndr").getAttribute("data-focs_date");
    var Crndr_date_Y = document.getElementById("deli_crnd_head_year").textContent;
    var Crndr_date_M = document.getElementById("deli_crnd_head_month").textContent;
    document.getElementById(Date_inp).value = Crndr_date_Y + "-" + Crndr_date_M + "-" + Crndr_date_value;
  };
};

document.addEventListener('click', function(e){
  if(!e.target.closest(".Cart_date_inputBox") && !e.target.closest("#Deli_date_crndr")) {
    document.getElementById("Deli_date_crndr").className = "Deli_date_crndr_hid";
  };
});